import { Button, Stack, Text } from '@chakra-ui/react'

import { getTutorUrl } from '@/client/services/url'

import type { PostDetails } from '@/components/Community/Post/types'
import ShwLink from '@/components/ShwLink'
import type { LiveHelpRequestWithNullableSessionDetails } from '@/components/Worlds/types'

import { isLiveHelpRequestWithSessionDetails } from './helpers'

export default function NonTutorLiveHelpBanner({
  post,
  liveHelpRequest,
}: {
  post: PostDetails
  liveHelpRequest: LiveHelpRequestWithNullableSessionDetails
}): JSX.Element {
  const { user } = post

  const header = isLiveHelpRequestWithSessionDetails(liveHelpRequest)
    ? `${user.displayName} is currently being helped by a tutor.`
    : `${user.displayName} is waiting for Zoom help.`

  return (
    <Stack
      direction={{ base: 'column', md: 'row' }}
      justify="space-between"
      align={{ base: 'left', md: 'center' }}
      width="100%"
      p="16px"
      bgColor="bg.muted"
      borderRadius="8px"
    >
      {/* TODO: AvatarGroup  */}
      <Stack spacing={0}>
        <Text fontWeight="bold">{header}</Text>
        <Text>
          Want to help students like {user.displayName} face-to-face? Become a tutor to help others
          over Zoom-plus host your own sessions and get other tutor perks.
        </Text>
      </Stack>
      <ShwLink href={getTutorUrl()}>
        <Button>Become A Tutor</Button>
      </ShwLink>
    </Stack>
  )
}
